import { render, staticRenderFns } from "./OrganizationSettingsUserChip.vue?vue&type=template&id=0a1235a7&scoped=true"
import script from "./OrganizationSettingsUserChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationSettingsUserChip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationSettingsUserChip.vue?vue&type=style&index=0&id=0a1235a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1235a7",
  null
  
)

export default component.exports